export default class ProgressBar {
    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    manageProgressBar() {
        var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var scrolled = (winScroll / height) * 100;
        document.getElementById("myBar").style.width = scrolled + "%";
    }

    bind() {
        var thisForget = this;
        document.addEventListener('scroll', function (event) {
            let pb = $('.progress-container-reader')[0];
            let bdc = $('.breadscrumbs-cont')[0];
            let headerGlobal = $('.header-global')[0];


            if (window.scrollY == 0) {
                bdc.classList.remove("d-none");
                pb.classList.add('drop');
                headerGlobal.classList.remove('d-none');
            } else {
                bdc.classList.add('d-none');
                pb.classList.remove('drop');
                headerGlobal.classList.add('d-none');
            }

            thisForget.manageProgressBar();
        });
    }
}
